// extracted by mini-css-extract-plugin
module.exports = {"PaddingUp":"styles_PaddingUp__6IdTA","form":"styles_form__3xjdf","title":"styles_title__3i4Md","Label":"styles_Label__1P2jz","button":"styles_button__nUTNQ"};